import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './LatePickUpFeeToggle.module.scss';
import React, { useState } from 'react';
import { Switch } from 'components/UI/V3/Forms/Switch';
import { Tooltip } from 'components/UI/V3/Tooltip/Tooltip';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import NumberField from 'components/UI/V3/Forms/NumberField';
import Spinner from 'components/UI/V3/Spinner';

interface LatePickUpFeeToggleProps {
    loading: boolean;
    checked: boolean;
    disabled?: boolean;
    currentValue?: number;
    setCurrentValue: (currentValue: number | undefined) => void;
    setChecked: () => void;
}

export const LatePickUpFeeToggle: React.FC<LatePickUpFeeToggleProps> = ({
    loading,
    checked,
    disabled,
    currentValue,
    setCurrentValue,
    setChecked
}) => {
    const [isLatePickupFeeEnabled, setIsLatePickupFeeEnabled] = useState(checked);

    const handleToggleChange = (checked: boolean) => {
        if (disabled) return;
        setIsLatePickupFeeEnabled(checked);
        setChecked();
    };

    const switchLine = (
        <div className={styles.switchContainer}>
            <span className={styles.inlineLabel}>Late Check Out Fee</span>
            <Tooltip
                content="Fee calculated based on your setup."
                placement="top"
            >
                <FontAwesomeIcon
                    icon={faInfoCircle}
                    className={styles.tooltipIcon}
                />
            </Tooltip>
            {loading ? (
                <Spinner size={25} />
            ) : (
                <Switch
                    className={styles.input}
                    checked={isLatePickupFeeEnabled}
                    disabled={disabled}
                    onChange={handleToggleChange}
                />
            )}
        </div>
    );

    const numberInput = (
        <NumberField
            value={currentValue || undefined}
            onChange={value => {
                if (disabled) return;
                setCurrentValue(value || undefined);
            }}
            placeholder="0.00"
            scale={2}
            startIcon={<span className={styles.dollarSign}>$</span>}
            disabled={disabled}
        />
    );

    return (
        <div className={styles.container}>
            {switchLine}
            {isLatePickupFeeEnabled && numberInput}
        </div>
    );
};

export default LatePickUpFeeToggle;
